import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
import { DEBUG_MODE } from '@angular/fire/compat/analytics';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { environment } from '../environments/environment';
import { provideHttpClient } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)), 
    provideAnalytics(() => getAnalytics()), ScreenTrackingService,
    providePerformance(() => getPerformance()),
    {provide: DEBUG_MODE, useValue: environment.analyticsDebugMode}, provideAnimationsAsync()
  ]
};
